'use strict';
import "../common.js";
import "../campaign.js";
import "../../_scss/ballet_pc/ballet_studio.scss";

((w, d) => {

    if(document.querySelectorAll('.p-ballet__studioTabListItem').length > 0){
        
        //スタジオエリアタブリスト
        document.querySelectorAll('.p-ballet__studioTabListItem').forEach((item) => {
            item.addEventListener('click', (obj) => {
                let _parent = null;
                let _tab_content = document.getElementById('p-ballet__studioTabContent');
                if(obj.target.className == 'p-ballet__studioTabListItemText'){
                    _parent = obj.target.parentNode;
                } else {
                    _parent = obj.target;
                }

                // Check is tab current or no current by class
                if(_parent.classList.length < 2){
                    //clear active tabs
                    document.querySelectorAll('.p-ballet__studioTabListItem').forEach((tab_i) => {
                        tab_i.className = 'p-ballet__studioTabListItem';
                    });
                    //set tab is active class
                    _parent.classList.add('p-ballet__studioTabListItem--is_active');
                    //Set tab content
                    _tab_content.innerHTML = _parent.children[1].innerHTML;
                    //Change url without reloading
                    window.history.pushState(null, null, '?region=' + _parent.dataset.code);
                }
            })
        });

        //最初のエリアを選択
        function init_studio_tab(index = 1){
            if(document.querySelectorAll('.p-ballet__studioTabListItem').length == 0) return false;
            let params = window.location.search.substring(1).split('&');
            let current = index; //最初のエリアのタブID
            const areas = ['hkd_thk', 'tyo', 'knt', 'chb', 'kns', 'chg_sik', 'kyu_oka'];

            params.forEach((item) => {
                let val = item.split('=');
                if( val[0] == 'region' && areas.includes(val[1]) ){
                    current = areas.indexOf(val[1]);
                    return false;
                }
            });
            document.querySelectorAll('.p-ballet__studioTabListItem')[current].click();
        }
        init_studio_tab();
    }


})(window, document);